import { ArchiveStatus, CostStatus, OcrStatus } from '@/tms/gbox-scans/_models/gbox-scans.model';

export const OCR_STATUS_LABELS: Readonly<Record<OcrStatus, string>> = {
	pending: 'Oczekuje na OCR',
	processing: 'Analizuję…',
	completed: 'Przeanalizowane',
	failed: 'Błąd OCR',
	skipped: 'Pominięte',
};

export const COST_STATUS_LABELS: Readonly<Record<CostStatus, string>> = {
	pending: 'Oczekuje',
	confirmed: 'Zatwierdzony',
	rejected: 'Odrzucony',
	skipped: 'Pominięto',
};

export const ARCHIVE_STATUS_LABELS: Readonly<Record<ArchiveStatus, string>> = {
	pending: 'Oczekuje',
	archived: 'Zarchiwizowano',
	failed: 'Błąd',
};
